import { twMerge } from "tailwind-merge";

/** Gabung className bersyarat, kelas Tailwind yang bentrok diselesaikan twMerge. */
export default function cn(...inputs) {
  return twMerge(inputs.filter(Boolean).join(" "));
}
